import {
    ActuatorsAppFilterPageAmDocument,
    ActuatorsAppFilterPageApDocument,
    ActuatorsAppFilterPageDocument,
    ActuatorsAppFilterPageEuDocument,
    ActuatorsAppFilterPagePrimaryDocument,
    ActuatorsAppFilterPageSecondaryDocument,
    ActuatorsListAmDocument,
    ActuatorsListAmQuery,
    ActuatorsListAmQueryVariables,
    ActuatorsListApDocument,
    ActuatorsListApQuery,
    ActuatorsListApQueryVariables,
    ActuatorsListEuDocument,
    ActuatorsListEuQuery,
    ActuatorsListEuQueryVariables,
    RegionsEnum,
    SolutionActuatorCommonFragmentDoc,
    VssActuatorAmFragmentDoc,
    VssActuatorApFragmentDoc,
    VssActuatorEuFragmentDoc,
} from 'src/generated/operations.ts';
import { FilterConfig } from 'src/utils/composeFilter.ts';
import { DocumentNode } from 'graphql/language/ast';
import { getHomePageConfig } from 'src/actuators/home/HomePageMapping.ts';
import { removeDuplicateFragments } from 'src/utils/de-dupe-fragments.ts';
import { generateFiltersConfig } from 'src/utils/generateFiltersConfig.ts';
import { generateItemsConfig } from 'src/utils/generateOrderItems.ts';

export type ActuatorsListPageData = Omit<
ActuatorsListEuQuery | ActuatorsListApQuery | ActuatorsListAmQuery, '__typename'>;
export type ActuatorsListPageVariables = Omit<
ActuatorsListEuQueryVariables | ActuatorsListApQueryVariables | ActuatorsListAmQueryVariables, '__typename'
>;

export type ActuatorProduct = ActuatorsListPageData['list']['results']['0'];

export type ActuatorsListPageConfig = {
    mainFilterConfig: FilterConfig;
    query: DocumentNode;
    filterConfig: FilterConfig;
    orderItemsConfig: FilterConfig;
    queryPrimary: DocumentNode;
    genericFilterQuery: DocumentNode;
    filterConfigPrimary: FilterConfig;
    filterConfigSecondary: FilterConfig;
}

export const getActuatorsListPageConfig = (region: RegionsEnum): ActuatorsListPageConfig | null => {
    const actuatorsPageConfig = getHomePageConfig(region);
    if (actuatorsPageConfig === null) {
        throw new Error('No Actuators Page Config');
    }
    const filterConfigPrimary = generateFiltersConfig(ActuatorsAppFilterPagePrimaryDocument, 'values');
    const queryPrimary = removeDuplicateFragments(ActuatorsAppFilterPagePrimaryDocument);
    const genericFilterQuery = removeDuplicateFragments(ActuatorsAppFilterPageDocument);
    const filterConfigSecondary = generateFiltersConfig(ActuatorsAppFilterPageSecondaryDocument, 'values');

    const { filterConfig: mainFilterConfig } = actuatorsPageConfig;
    if (region === RegionsEnum.Eu) {
        return {
            query: removeDuplicateFragments(ActuatorsListEuDocument),
            filterConfig: generateFiltersConfig(ActuatorsAppFilterPageEuDocument, 'values'),
            orderItemsConfig: [
                ...generateItemsConfig(SolutionActuatorCommonFragmentDoc),
                ...generateItemsConfig(VssActuatorEuFragmentDoc),
            ],
            mainFilterConfig: [
                ...mainFilterConfig,
                ['label', 'label'],
            ],
            filterConfigPrimary,
            queryPrimary,
            genericFilterQuery,
            filterConfigSecondary,
        };
    }
    if (region === RegionsEnum.Ap) {
        return {
            query: removeDuplicateFragments(ActuatorsListApDocument),
            filterConfig: generateFiltersConfig(ActuatorsAppFilterPageApDocument, 'values'),
            orderItemsConfig: [
                ...generateItemsConfig(SolutionActuatorCommonFragmentDoc),
                ...generateItemsConfig(VssActuatorApFragmentDoc),
            ],
            mainFilterConfig: [
                ...mainFilterConfig,
                ['label', 'label'],
            ],
            filterConfigPrimary,
            queryPrimary,
            genericFilterQuery,
            filterConfigSecondary,
        };
    }
    if (region === RegionsEnum.Am) {
        return {
            query: removeDuplicateFragments(ActuatorsListAmDocument),
            filterConfig: generateFiltersConfig(ActuatorsAppFilterPageAmDocument, 'values'),
            orderItemsConfig: [
                ...generateItemsConfig(SolutionActuatorCommonFragmentDoc),
                ...generateItemsConfig(VssActuatorAmFragmentDoc),
            ],
            mainFilterConfig: [
                ...mainFilterConfig,
                ['label', 'label'],
            ],
            filterConfigPrimary,
            queryPrimary,
            genericFilterQuery,
            filterConfigSecondary,
        };
    }
    return null;
};
